import BlockRendererClient from './BlocksRenderClient';
export default BlockRendererClient;
